import { GuardRutasGuard } from './guard-rutas.guard';
import {Routes, RouterModule} from '@angular/router';
import {MainLayoutComponent} from "./shared/layout/app-layouts/main-layout.component";
import {AuthLayoutComponent} from "./shared/layout/app-layouts/auth-layout.component";
import {ModuleWithProviders} from "@angular/core";
import {CanAccessService} from "./shared/canaccess/canAccess.service";

export const routes: Routes = [
    {
        path: 'gestion-megan',
        loadChildren: 'app/gestion-megan/gestion-megan.module#GestionMeganModule',
        data: { pageTitle: 'Gestion de Megan', permiso: 'view.megan.management' },
        component: MainLayoutComponent,
        canActivate: [CanAccessService, GuardRutasGuard]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        loadChildren: 'app/+login/auth.module#AuthModule',
    },
        {
        path: 'dashboard-ot',
        loadChildren: 'app/dashboard-ot/dashboard-ot.module#DashboardOtModule',
        component: MainLayoutComponent,
        data: { pageTitle: 'Dashboard OT', permiso: 'dashboard.ot' },
        canActivate: [CanAccessService, GuardRutasGuard]
    },
    {
        path: 'home',
        loadChildren: 'app/+home/home.module#HomeModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'dashboard-operaciones',
        loadChildren: 'app/dashboard-operaciones/dashboard-operaciones.module#DashboardOperacionesModule',
        component: MainLayoutComponent,
        data: { pageTitle: 'Dashboard Operaciones', permiso: 'dashboard.complete.operations' },
        canActivate: [CanAccessService, GuardRutasGuard]
    },
    {
        path: 'dashboard-recuperadores',
        loadChildren: 'app/dashboard-recuperadores/dashboard-recuperadores.module#DashboardRecuperadoresModule',
        component: MainLayoutComponent,
        data: { pageTitle: 'Dashboard Recuperadores', permiso: 'panel.recuperadores' },
        canActivate: [CanAccessService, GuardRutasGuard]
    },
    {
        path: 'clientes',
        loadChildren: 'app/+clientes/clientes.module#ClientesModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard],data:{permiso:'view.customer'}
    },
    {
        path: 'new-agenda',
        loadChildren: 'app/agenda/new-agenda.module#NewAgendaModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'new-agenda-supervisor',
        loadChildren: 'app/agendaSupervisor/new-agenda-supervisor.module#NewAgendaModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'agenda',
        loadChildren: 'app/+agenda/agenda.module#AgendaModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'agenda-user',
        loadChildren: 'app/+agenda-user/agenda.module#AgendaModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'gps',
        loadChildren: 'app/+gps/gps.module#GpsModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'geocercas',
        loadChildren: 'app/+geocercas/geocercas.module#GeocercasModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard],data:{permiso:'view.geo'}
    },
    {
        path: 'geocercasAlerta',
        loadChildren: 'app/geocercas-alert/geocercas-alert.module#GeocercasAlertModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard],data:{permiso:'view.geo.alert'}
    },
    {
        path: 'tickets',
        loadChildren: 'app/+tickets/tickets.module#TicketsModule',
        data: {pageTitle: 'Tickets'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'folios',
        loadChildren: 'app/folios/folios.module#FoliosModule',
        data: {pageTitle: 'Folios electrónicos',permiso:'view.folio'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
    },
    {
        path: 'gestion',
        loadChildren: 'app/gestion-ventas/gestion-ventas.module#GestionVentasModule',
        data: {pageTitle: 'Gestion de Ventas',permiso:'view.sale.management'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
    },
    {
        path: 'supervision-ventas',
        loadChildren: 'app/supervision-ventas/supervision-ventas.module#SupervisionVentasModule',
        data: { 
            pageTitle: 'Supervisar Ventas',
            permiso: 'view.sale.admin'
        },
        component: MainLayoutComponent,
        canActivate: [CanAccessService, GuardRutasGuard]
    },
    {
        path: 'gestion-offline',
        loadChildren: 'app/gestion-ventas-offline/gestion-ventas-offline.module#GestionVentasOfflineModule',
        data: {pageTitle: 'Gestion de Ventas Offline',permiso:'view.sales.offline'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
        
    },
    {
        path: 'gestion-vehicular',
        loadChildren: 'app/gestion-vehicular/gestion-vehicular.module#GestionVehicularModule',
        data: {pageTitle: 'Gestion Vehicular',permiso:'view.vehicule'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
        
    },
    {
        path: 'punto-venta',
        loadChildren: 'app/punto-venta/punto-venta.module#PuntoVentaModule',
        data: {pageTitle: 'Punto de Venta',permiso:'view.point.sale'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
        
    },
    {
        path: 'notifications',
        loadChildren: 'app/notificaciones/notificaciones.module#NotificacionesModule',
        data: {pageTitle: 'Notificaciones'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    // {
    //     path: 'turnosLaborales',
    //     loadChildren: 'app/+turnosLaborales/turnos.module#TurnosModule',
    //     data: {pageTitle: 'Turnos Laborales'},
    //     component: MainLayoutComponent,
    //     canActivate: [CanAccessService]
    // },
    {
        path: 'formatos',
        loadChildren: 'app/+formatos/formatos.module#FormatosModule',
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard],data:{permiso:'view.format'}
    },
    {
        path: 'admin',
        loadChildren: 'app/+admin/admin.module#AdminModule',
        data: {pageTitle: 'Administration'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'tareas',
        loadChildren: 'app/+tareas/tareas.module#TareasModule',
        data: {pageTitle: 'Tareas'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: '0Tab',
        loadChildren: 'app/+admin/+users/users.module#UsersModule',
        data: {pageTitle: 'Users'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: '1Tab',
        loadChildren: 'app/+admin/+users/users.module#UsersModule',
        data: {pageTitle: 'Users'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: '2Tab',
        loadChildren: 'app/+admin/+users/users.module#UsersModule',
        data: {pageTitle: 'Users'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: '3Tab',
        loadChildren: 'app/+admin/+users/users.module#UsersModule',
        data: {pageTitle: 'Users'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: '4Tab',
        loadChildren: 'app/+admin/+users/users.module#UsersModule',
        data: {pageTitle: 'Users'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'metrocarrier',
        loadChildren: 'app/+metrocarrier/metrocarrier.module#MetrocarrierModule',
        data: {pageTitle: ''},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'salesFolder',
        loadChildren: 'app/+carpetaVentas/carpetaVentas.module#SalesFolderModule',
        data: {pageTitle: 'Sales Folder',permiso:'view.sales.folder'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
    },
    {
        path: 'trainingFolder',
        loadChildren: 'app/+carpetaCapacitacion/carpetaCapacitacion.module#TrainingFolderModule',
        data: {pageTitle: 'Training Folder',permiso:'view.training.folder'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
    },
    {
        path: 'maintenanceFolder',
        loadChildren: 'app/+carpetaMantenimiento/carpetaMantenimiento.module#MaintenanceFolderModule',
        data: {pageTitle: 'Maintenance Folder'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'operationsFolder',
        loadChildren: 'app/+carpetaOperaciones/carpetaOperaciones.module#OperationsFolderModule',
        data: {pageTitle: 'Operations Folder'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'technicalRecord',
        loadChildren: 'app/technical-record/technical-record.module#TechnicalRecordModule',
        data: {pageTitle: 'Memoria Técnica'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService]
    },
    {
        path: 'devices',
        loadChildren: 'app/devices/devices.module#DevicesModule',
        data: {pageTitle: 'Gestion Dispositivos',permiso:'view.devices'},
        component: MainLayoutComponent,
        canActivate: [CanAccessService,GuardRutasGuard]
        
    },
    {
        path: 'ventas-con-error',
        loadChildren: 'app/sales-with-error/sales-with-error.module#SalesWithErrorModule',
        data: {pageTitle: 'Ventas con error', 
        permiso:'view.sales.with.error'
        },
        component: MainLayoutComponent,
        canActivate: [CanAccessService, GuardRutasGuard]
    },
    {
        path: 'megan',
        loadChildren: 'app/megan/megan.module#MeganModule',
        data: {
            pageTitle: 'Habla con Megan',
            permiso: ''
        },
    },
    {
        path: 'ruta-supervision-mtto',
        loadChildren: 'app/ruta-supervision-mtto/ruta-supervision-mtto.module#RutaSupervisionMttoModule', 
        component: MainLayoutComponent,
        data: { pageTitle: 'Ruta Supervisión Mantenimiento' },
        canActivate: [CanAccessService]
    },
    {
        path: '**', redirectTo: ''
    },
];
export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});
